module.exports = __webpack_public_path__ + "img/413.b273504c.png";